module.exports = __webpack_public_path__ + "static/storytimeOG-2a19e88fb3640b6a784ec51b5a9a9975.jpg";